import { makeAutoObservable, observable  } from "mobx";
import { FlowsationPerformanceService } from "../services/FlowsationPerformanceService";

class FlowstationProductionTrendStore {
  constructor() {
    makeAutoObservable(this);
  }

  selectedFlowstation = { flowstationId: "1", flowsationName: "AKRI FS" };
  isIniatilizing = false;
  isLoading = false;
  uniqueFlowstations = [];
  plotData = [];
  isproducing = true;
  async getuniqueFlowstationsData() {
    try {
      this.isIniatilizing = true;

      const res = await FlowsationPerformanceService.getuniqueFlowstationsData(
        this.isproducing
      );
      this.uniqueFlowstations = [...res];

      this.isIniatilizing = false;
    } catch (error) {
      throw error;
    } finally {
      this.isIniatilizing = false;
    }
  }
  async getFlowstationPlotData(flowstationId = this.selectedFlowstation) {
    try {
      this.isIniatilizing = true;

      const res = await FlowsationPerformanceService.getFlowstationPlotData(
        flowstationId
      );
      this.plotData = [...res];
      console.log("data", res);

      this.isIniatilizing = false;
    } catch (error) {
      throw error;
    } finally {
      this.isIniatilizing = false;
    }
  }
}



const flowstationProductionTrendStore = new FlowstationProductionTrendStore();
export default flowstationProductionTrendStore;

